import { e as entry, t as throttle, f as handleUrl } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';
import __vue_component__$1 from './Panorama.js';
import './hotspots.js';

//
var script = {
  mixins: [entry],
  components: {
    Panorama: __vue_component__$1
  },
  created: function created() {
    this.onHotspotClicked = throttle(this.onHotspotClicked);
  },
  mounted: function mounted() {
    // store last panorama
    var pageId = null;
    console.log(this.pageData.Class);

    if (this.pageData.Class.includes('Panorama')) {
      pageId = this.pageData.ID;
    }

    if (this.pageData.Class === 'XpHome') {
      pageId = parseInt(this.$xp.navigation.activeTabId);
    }

    var homePageId = this.pageData.Homepage ? this.pageData.Homepage.ID : this.$xp.history.lastHomePage ? this.$xp.history.lastHomePage.pageId : null;
    this.$xp.history.setLastPanoramaPage(pageId, homePageId);
  },
  methods: {
    onHotspotClicked: function onHotspotClicked(hotspot) {
      if (hotspot.href.length > 0) {
        handleUrl(hotspot.href, this.$router);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-panorama-entry" },
    [
      _c("panorama", {
        attrs: {
          type: _vm.entryData.Json.PanoramaType,
          src: _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Image.Url,
          thumb: _vm.entryData.Image.Thumb,
          hotspots: _vm.entryData.Json.ImageMap,
          startLookAtX: _vm.entryData.Json.StartLookAtX,
          width: _vm.entryData.Width,
          height: _vm.entryData.Height
        },
        on: { "hotspot-click": _vm.onHotspotClicked }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=PanoramaEntry.js.map
